import React, { useEffect, useState } from 'react';
import { useAuth } from './hooks/useAuth';
import LandingPage from './pages/LandingPage';
import AddTreePage from './pages/AddTreePage';
import GardenPage from './pages/GardenPage';
import './styles/global.css';

const App: React.FC = () => {
    const [route, setRoute] = useState<string>(window.location.hash || '#/');
    const { session, isLoadingAuth, logout } = useAuth();

    useEffect(() => {
        const onHashChange = () => setRoute(window.location.hash || '#/');
        window.addEventListener('hashchange', onHashChange);

        // Redirect logic: If logged in and hitting the root URL, go to Garden
        if (session && (window.location.hash === '' || window.location.hash === '#/')) {
            window.location.hash = '#/garden';
        }

        return () => window.removeEventListener('hashchange', onHashChange);
    }, [session]);

    if (isLoadingAuth) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-white text-gray-500">
                Loading...
            </div>
        );
    }

    if (route.startsWith('#/dashboard')) {
        if (!session) {
            window.location.hash = '#/';
            return null;
        }
        return <AddTreePage session={session} logout={logout} />;
    }

    if (route.startsWith('#/garden')) {
        if (!session) {
            window.location.hash = '#/';
            return null;
        }
        return <GardenPage session={session} logout={logout} />;
    }

    // Default route
    return <LandingPage session={session} logout={logout} />;
};

export default App;